import { useQuery } from '@tanstack/react-query'
import { resultQueryFn } from '@/shared/utils/queryHelpers'
import { queryKeys } from '@/shared/utils/queryKeys'
import { searchModels, getModelDetail, getProviders } from './api'

export function useSearchModels(
  query: string,
  provider?: string,
  resourceType?: string,
  page?: number,
  pageSize?: number,
) {
  return useQuery({
    queryKey: queryKeys.search.models(query, provider, resourceType, page, pageSize),
    queryFn: resultQueryFn(() => searchModels(query, provider, resourceType, page, pageSize)),
    enabled: query.length >= 2,
    staleTime: 60_000,
  })
}

export function useModelDetail(provider?: string, externalId?: string) {
  return useQuery({
    queryKey: queryKeys.search.modelDetail(provider!, externalId!),
    queryFn: resultQueryFn(() => getModelDetail(provider!, externalId!)),
    enabled: provider !== undefined && externalId !== undefined,
  })
}

export function useSearchProviders() {
  return useQuery({
    queryKey: queryKeys.search.providers,
    queryFn: resultQueryFn(getProviders),
    staleTime: 5 * 60_000,
  })
}
